import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/index.css'
import MfaEnrollmentScreen from '../screens/MfaEnrollmentScreen'
import { ensureUniversalLoginContext } from '@/utils/helpers/universalLoginContext.ts'

async function bootstrap() {
  await ensureUniversalLoginContext('mfa-begin-enroll-options')
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <MfaEnrollmentScreen />
    </StrictMode>,
  )
}

bootstrap()
